type Theme = "gea" | "gecontur" | "geabrasil"

const viteEnv = import.meta.env as ImportMetaEnv

const missing: string[] = []
if (!viteEnv.VITE_GECONTUR_URL) missing.push("VITE_GECONTUR_URL")
if (!viteEnv.VITE_API) missing.push("VITE_API")
if (!viteEnv.VITE_THEME) missing.push("VITE_THEME")
if (!viteEnv.VITE_LOGO) missing.push("VITE_LOGO")
if (!viteEnv.VITE_COMPANY) missing.push("VITE_COMPANY")
if (!viteEnv.VITE_TITLE) missing.push("VITE_TITLE")
if (!viteEnv.VITE_CURRENCY) missing.push("VITE_CURRENCY")

if (missing.length) {
  throw new Error(
    `Missing required environment variables: ${missing.join(", ")}`,
  )
}

const theme = viteEnv.VITE_THEME as Theme
if (theme !== "gea" && theme !== "gecontur" && theme !== "geabrasil") {
  throw new Error(`Invalid VITE_THEME: ${viteEnv.VITE_THEME}`)
}

export const env = {
  geconturUrl: viteEnv.VITE_GECONTUR_URL,
  apiUrl: viteEnv.VITE_API,
  theme,
  logo: viteEnv.VITE_LOGO,
  company: viteEnv.VITE_COMPANY,
  title: viteEnv.VITE_TITLE,
  currency: viteEnv.VITE_CURRENCY,
  isGea: theme === "gea",
  isGeaBrasil: theme === "geabrasil",
  isGecontur: theme === "gecontur",
}
